import { graphConfig } from "../../../config/authConfig";
import axios from 'axios';

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
export async function msGraphGetProfileImage(accessToken) {
    const bearer = `Bearer ${accessToken}`;

    return axios.get(`${graphConfig.graphMeEndpoint}/photo/$value`, {
        responseType: 'arraybuffer',
        headers:
            { Authorization: bearer }
    }).then((response) => {
        let image = btoa(
            new Uint8Array(response.data)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
        return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
    });
}
